import cntl from "cntl";
import PropTypes from "prop-types";
import { useMemo, useState } from "react";
import { POSITIONS, COLOR, SIZE } from "../constants";
import SectionContent from "./SectionContent";

const propTypes = {
  theme: PropTypes.oneOf([
    "",
    COLOR.dark,
    COLOR.gray,
    COLOR.light,
    COLOR.primary,
    COLOR.primary_light,
  ]),
};

function SectionHeroHeader({ background, theme, content, children }) {
  const [bgColor, setBgColor] = useState("");

  const wrapperCn = () => cntl`
    relative
    ${bgColor}
  `;

  useMemo(() => {
    switch (theme) {
      case COLOR.dark:
        setBgColor("bg-gray-light-10 dark:bg-gray-dark-10");
        break;
      case COLOR.gray:
        setBgColor("bg-gray-light-2 dark:bg-gray-dark-2");
        break;
      case COLOR.primary:
        setBgColor("bg-primary-light-10 dark:bg-primary-dark-10");
        break;
      case COLOR.primary_light:
        setBgColor("bg-primary-light-2 dark:bg-primary-dark-2");
        break;
      case COLOR.light:
        setBgColor("bg-white dark:bg-black");
        break;
      default:
        setBgColor("bg-white dark:bg-black");
        break;
    }
  }, [theme]);

  return (
    <div className={wrapperCn()}>
      {background && background}
      <div className="grid grid-cols-1 md:grid-cols-2">
        <div className="flex justify-start md:justify-end">
          <div className="w-full max-w-xl">
            <div className="px-4 md:px-8 py-16 md:py-40">
              <SectionContent {...content} />
            </div>
          </div>
        </div>
        {children && children}
      </div>
    </div>
  );
}

SectionHeroHeader.prototype = propTypes;
export default SectionHeroHeader;
